<div class="grafico-container">
  @if (chartOptions()) {
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions()"
      [oneToOne]="true"
      [(update)]="updateFlag"
      [callbackFunction]="chartCallback"
    ></highcharts-chart>
  }
</div>
